import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/checkmark-white.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-xl" }, "Onboarding", -1)
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "w-3 h-3"
}
const _hoisted_5 = { class: "ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.completedTasks !== _ctx.list.length && _ctx.list.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _hoisted_3,
          _createTextVNode(" (" + _toDisplayString(_ctx.completedTasks) + "/" + _toDisplayString(_ctx.list.length) + ") completed tasks", 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "flex flex-row items-center mb-2"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex items-center justify-center rounded-full w-5 h-5", {
          'bg-gray-200': !item.completed,
          'bg-primary': item.completed,
        }])
            }, [
              (item.completed)
                ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("span", _hoisted_5, _toDisplayString(item.description), 1)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}